// extracted by mini-css-extract-plugin
module.exports = {"container":"LinksToSearchV2-module__container","moreLink":"LinksToSearchV2-module__moreLink"};